<!--
    Summary:
        hkml.exhibition.web - p5-n-prenata-test-type
    ChangeLog:
        wangn on 2020/11/28 added
-->
<template>
  <div class="v-p5-n-prenata-test-type" title="p5-n-prenata-test-type">
    <div class="header">
      <h2>{{$t('NPrenatalTest.p5_title')}}</h2>
    </div>
    <div class="content content-cn">
      <div class="box">
        <img src="../../../assets/images/projects/n-prenata-test/type1.png"/>
      </div>
      <div class="box">
        <img src="../../../assets/images/projects/n-prenata-test/type2.png"/>
      </div>
      <div class="box">
        <img src="../../../assets/images/projects/n-prenata-test/type3.png"/>
      </div>
    </div>
    <div class="content content-en">
      <div class="box">
        <img src="../../../assets/images/projects/n-prenata-test/type1-en.png"/>
      </div>
      <div class="box">
        <img src="../../../assets/images/projects/n-prenata-test/type2-en.png"/>
      </div>
      <div class="box">
        <img src="../../../assets/images/projects/n-prenata-test/type3-en.png"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "p5-n-prenata-test-type"
  }
</script>

<style scoped lang="scss">
  .en .v-n-prenata-test .v-p5-n-prenata-test-type {
    .content {
      &.content-cn {
        display: none;
      }
      &.content-en {
        display: flex;
      }
    }
  }
</style>
<style scoped lang="scss">
  .v-p5-n-prenata-test-type {
    text-align: center;
    padding:  4.5vw 13vw;
    .header{
      margin-bottom: 3.5vw;
      h2{
        color: #273a63;
        font-size: 2.66vw;
        font-weight: bold;
      }
    }
    .content{
      &.content-cn {
        display: flex;
      }
      &.content-en {
        display: none;
      }
      justify-content: space-between;
      .box{
        img{
          width: 18.96vw;
          height: 17.81vw;
        }
      }
    }

  }
</style>




// WEBPACK FOOTER //
// src/view/projects/n-prenata-test/p5-n-prenata-test-type.vue